import '@fancyapps/fancybox'

export function handleRequirePrice() {
  const requireEl = document.querySelector('.js-require-price')

  if (!requireEl) {
    return
  }

  requireEl.addEventListener('click', () => {
    $.fancybox.open(document.getElementById('form_11'))
  })
}
